export enum AutoSaveContactSource {
  Off = 1,
  To = 2,
  ToCc = 3,
}
